import * as React from 'react';
import {
    Edit,
    SimpleForm,
    TextInput,
    useRecordContext,
    minValue, DateTimeInput,
    required,
    AutocompleteInput,
    useDataProvider,
} from 'react-admin';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import InfoModal from './InfoModal';
import { EditToolbar } from "../../common/EditToolbar";
import PermissionGuard from '../../common/PermissionGuard';
import useIsPermission from '../../hooks/useIsPermission';
import { SegmentRender } from './CampaignCreate';
import { validateNotEmpty } from '../../common/VideoPlayer/util';

const CampaignEdit = () => {
    const [open, setOpen] = React.useState(false);
    const { isUpdatable } = useIsPermission("CAMPAIGNS");
    const [segments, setSegments] = React.useState([]) as any;
    const dataProvider = useDataProvider();

    React.useEffect(() => {
        dataProvider
            .getList('segmentations', {
                pagination: { page: 1, perPage: 100 },
                sort: { field: 'name', order: 'ASC' },
                filter: {},
            })
            .then(({ data }) => setSegments(data))
            .catch((error) => console.error(error));
    }, [dataProvider]);

    return (
        <PermissionGuard permission={isUpdatable}>
            <Edit mutationMode={'pessimistic'} title={<CampaignTitle />}>
                <SimpleForm toolbar={<EditToolbar />}>
                    <div onClick={() => setOpen(true)} className="w-full px-5 flex flex-row gap-1 items-center justify-end">
                        <InfoOutlinedIcon className='cursor-pointer my-3 justify-end ' sx={{ color: 'blue' }} />
                        <p>info </p>
                    </div>
                    <TextInput source="name" fullWidth validate={[required(), validateNotEmpty]} />
                    <TextInput source="title" fullWidth validate={[required(), validateNotEmpty]} />
                    <TextInput source="message" fullWidth validate={[required(), validateNotEmpty]} multiline rows={5} />
                    <DateTimeInput source="startsAt" validate={[required()]} fullWidth />
                    <AutocompleteInput
                        source="segmentId"
                        choices={segments}
                        optionText={SegmentRender}
                        fullWidth
                        isRequired
                    />

                </SimpleForm>
            </Edit>
            <InfoModal open={open} setOpen={setOpen} />
        </PermissionGuard>
    )
};

const CampaignTitle = () => {
    const record = useRecordContext<any>();
    return record ? (
        <span>
            {record.name}&quot;
        </span>
    ) : null;
};

export default CampaignEdit;
